import Meta from '@/components/common/Meta';
import DashboardView from '@/views/dashboard/DashboardView';

export default function Home() {
  return (
    <>
      <Meta title="Fanlab" />
      <DashboardView />
    </>
  );
}
